import type { MetricsInfo } from 'owa-calendar-compose-types';
import { QuickComposeEntrySourceType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

export default function createQuickComposeMetricsInfo(
    entrySource: QuickComposeEntrySourceType
): MetricsInfo {
    let metricsInfo = {
        quickComposeEntrySource: entrySource,
        quickComposeControlUsageMetrics: {
            usageDict: {},
            startTimeDict: {},
            durationDict: {},
        },
    } as MetricsInfo;

    return metricsInfo;
}
